import React, { useState } from "react";
import "./Textarea.scss";

const Textarea = ({ label, placeholder, error, errorMessage, name, onChange, ...props }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [value, setValue] = useState("");

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(value !== "");
  const handleChange = (e) => {
    setValue(e.target.value);
    if (onChange) onChange(e);
  };

  return (
    <div className={`textarea-container ${isFocused || value ? "focused" : ""} ${error ? "error" : ""}`}>
      <textarea
        id={name}
        name={name}
        placeholder={placeholder}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        value={value}
        {...props}
      />
      <label htmlFor={name}>{label}</label>
      {error && <span className="error-message">{errorMessage}</span>}
    </div>
  );
};

export default Textarea;

